import React from "react";
import { Issue } from "@adsk/acc-issues-types";
import { useTranslations } from "@adsk/acc-issues-translations";
import { useSelector } from "@adsk/acc-issues-core/state/redux/hooks";
import { getTotalNumOfIssueAttachments } from "@adsk/acc-issues-core/state/redux/ducks/issueAttachments";

export const AttachmentsDisplay = ({ issue }: { issue: Issue }) => {
  const { T } = useTranslations();
  const totalNumOfIssueAttachments = useSelector(getTotalNumOfIssueAttachments)(
    issue?.id
  );
  const attachmentsCountToDisplay =
    totalNumOfIssueAttachments || issue.attachmentCount;

  const text =
    attachmentsCountToDisplay > 1
      ? "attachmentsCountPlural"
      : "attachmentsCountSingular";

  return (
    <div>
      {attachmentsCountToDisplay
        ? T.translate(`issueTable.attachmentsColumn.${text}`, {
            attachmentsCount: attachmentsCountToDisplay,
          })
        : "-"}
    </div>
  );
};
